import { deleteApiCaller, getApiCaller, postApiCaller, putApiCaller } from "../apiCaller";

export const getVideos = async (currentPage, itemsPerPage, search, categoryId = undefined) => {
    let url = `video/get-all?page=${currentPage}&limit=${itemsPerPage}&search=${search}&includeHidden=true`;
    if (categoryId !== undefined) {
        url += `&categoryId=${categoryId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const getVideoById = async (id) => {
    const response = await getApiCaller(`video/${id}`);
    return response;
}

export const addVideo = async (payload) => {
    const response = await postApiCaller("video/create", payload);
    return response;
}

export const updateVideo = async (id, payload) => {
    const response = await putApiCaller(`video/update/${id}`, payload);
    return response;
}

export const deleteVideo = async (id) => {
    const response = await deleteApiCaller(`video/delete/${id}`);
    return response;
}

export const videoSequence = async (payload) => {
    const response = await putApiCaller("video/sequence", payload);
    return response;
}

export const incrementVideoView = async (id) => {
    const response = await postApiCaller(`video/${id}/view`, {});
    return response;
}

export const swapVideoWithPage = async (payload) => {
    const response = await putApiCaller("video/swap-page", payload);
    return response;
}
